import { render, staticRenderFns } from "./ReferralProgram.vue?vue&type=template&id=bc60081c&scoped=true&"
import script from "./ReferralProgram.vue?vue&type=script&lang=ts&"
export * from "./ReferralProgram.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralProgram.vue?vue&type=style&index=0&id=bc60081c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc60081c",
  null
  
)

export default component.exports